// extracted by mini-css-extract-plugin
export var layoutContainer = "_dt-0";
export var layoutContainerNoRounding = "_dt-6";
export var layoutContainerOpen = "_dt-5";
export var layoutContainerResizing = "_dt-1";
export var mainContent = "_dt-2";
export var resizeDivider = "_dt-3";
export var slidePanel = "_dt-4";